import { createSelector } from "reselect"
import lodash from "lodash"

const state = s => s.CronOrder

export const selectId = (_, props) => lodash.get(props, "match.params.id")

export const selectError = createSelector(state, s => s.error)

export const makeSelectOrder = () => createSelector(state, state => state.order)

export const makeSelectIsLoading = () =>
  createSelector(state, state => state.isLoading)
